import { Controller } from '@hotwired/stimulus';
import { enter, leave } from '../transition';

export default class extends Controller {
    static targets = ['btnIconOpen', 'btnIconClose', 'content'];
    static values = {
        expanded: { type: Boolean, default: false }
    };

    connect() {
        this.updateBtnIcons();
        this.updateContent();
    }

    toggle() {
        this.expandedValue = !this.expandedValue;

        if (this.expandedValue) {
            enter(this.contentTarget).then();
        } else {
            leave(this.contentTarget).then();
        }

        this.updateBtnIcons();
    }

    updateBtnIcons() {
        this.btnIconOpenTarget.classList.toggle('hidden', this.expandedValue);
        this.btnIconCloseTarget.classList.toggle('hidden', !this.expandedValue);
    }

    updateContent() {
        const attributes = {
            class: 'overflow-hidden',
            'data-transition-enter-end': 'grid grid-rows-[1fr] opacity-100',
            'data-transition-enter-start': 'grid grid-rows-[0fr] opacity-0',
            'data-transition-enter': 'transition-all duration-300 ease-out',
            'data-transition-leave-end': 'grid grid-rows-[0fr] opacity-0',
            'data-transition-leave-start': 'grid grid-rows-[1fr] opacity-100',
            'data-transition-leave': 'transition-all duration-300 ease-in'
        };

        for (const [attr, value] of Object.entries(attributes)) {
            if (!this.contentTarget.hasAttribute(attr)) {
                this.contentTarget.setAttribute(attr, value);
            }
        }

        this.contentTarget.classList.toggle('hidden', !this.expandedValue);
        this.contentTarget.classList.toggle('opacity-0', !this.expandedValue);

        const wrapper = document.createElement('div');
        wrapper.classList.add('overflow-hidden');

        while (this.contentTarget.firstChild) {
            wrapper.appendChild(this.contentTarget.firstChild);
        }

        this.contentTarget.appendChild(wrapper);
    }
}
